import React from 'react';
import { Link } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { useCart } from '../../context/CartContext';

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();

  const handleAddToCart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addToCart(product);
  };

  return (
    <Link
      to={`/product/${product.slug}`}
      className="group flex flex-col bg-white rounded-2xl overflow-hidden border border-dark-100 hover:border-athletic-200 hover:shadow-soft transition-all duration-300"
    >
      {/* Image */}
      <div className="aspect-square bg-dark-50 relative overflow-hidden">
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        {product.badge && (
          <span className="absolute top-3 left-3 px-3 py-1 text-dark-700 text-[11px] font-semibold uppercase tracking-wide rounded-full bg-white/90 backdrop-blur border border-dark-100">
            {product.badge}
          </span>
        )}
      </div>

      {/* Info */}
      <div className="p-5 flex flex-col flex-grow">
        <p className="text-[11px] font-medium uppercase tracking-wider text-athletic-600 mb-1.5">
          {product.categorySlug?.replace(/-/g, ' ')}
        </p>
        <h3 className="font-medium text-dark-900 mb-4 group-hover:text-athletic-700 transition-colors line-clamp-2 flex-grow">
          {product.name}
        </h3>
        <div className="flex items-center justify-between mt-auto">
          <p className="text-lg font-semibold text-dark-900">${product.price.toFixed(2)}</p>
          <button
            onClick={handleAddToCart}
            aria-label="Add to cart"
            className="inline-flex items-center gap-1.5 pl-3 pr-3.5 py-2 rounded-full bg-dark-900 text-white text-sm font-medium hover:bg-athletic-600 transition-colors"
          >
            <Plus className="w-4 h-4" /> Add
          </button>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
